// ESM port of @mapbox/geo-viewport@0.5.0 (latest ever published; upstream
// dormant) with one fix: its `fetchMerc` assigns `antiMeridian` without `var`,
// an implicit global that webpack's sloppy-mode CJS tolerated but that throws
// ReferenceError once Vite converts the module to (always-strict) ESM. The
// same landmine is already documented in
// src/screens/.../ViewOnMapDrawer/helpers/index.ts, which reimplemented the
// math inline to avoid it. Aliased via vite.config.mjs; jest still resolves the
// real package.
import SphericalMercator from '@mapbox/sphericalmercator';

// SphericalMercator pre-caches calculations per tile size on instantiation;
// cache instances to avoid repeating that cost.
const smCache = {};

function fetchMerc(tileSize, allowAntiMeridian) {
  const size = tileSize || 256;
  const antiMeridian = allowAntiMeridian || false;

  const cacheKey = size + String(antiMeridian);
  if (!smCache[cacheKey]) {
    smCache[cacheKey] = new SphericalMercator({
      size,
      antimeridian: antiMeridian
    });
  }

  return smCache[cacheKey];
}

function getAdjusted(base, ratios, allowFloat) {
  const adjusted = Math.min(
    base - Math.log(ratios[0]) / Math.log(2),
    base - Math.log(ratios[1]) / Math.log(2)
  );

  return allowFloat ? adjusted : Math.floor(adjusted);
}

export function viewport(
  bbox,
  dimensions,
  minzoom,
  maxzoom,
  tileSize,
  allowFloat,
  allowAntiMeridian
) {
  const min = minzoom === undefined ? 0 : minzoom;
  const max = maxzoom === undefined ? 20 : maxzoom;
  const merc = fetchMerc(tileSize, allowAntiMeridian);
  const base = max;
  const bl = merc.px([bbox[0], bbox[1]], base);
  const tr = merc.px([bbox[2], bbox[3]], base);
  const width = tr[0] - bl[0];
  const height = bl[1] - tr[1];
  const centerPixelX = bl[0] + width / 2;
  const centerPixelY = tr[1] + height / 2;
  const ratios = [width / dimensions[0], height / dimensions[1]];
  const adjusted = getAdjusted(base, ratios, allowFloat);

  const center = merc.ll([centerPixelX, centerPixelY], base);
  const zoom = Math.max(min, Math.min(max, adjusted));

  return { center, zoom };
}

export function bounds(viewportCoords, zoom, dimensions, tileSize) {
  let coords = viewportCoords;
  if (coords.lon !== undefined) {
    coords = [coords.lon, coords.lat];
  }

  const merc = fetchMerc(tileSize);
  const px = merc.px(coords, zoom);
  const tl = merc.ll(
    [px[0] - dimensions[0] / 2, px[1] - dimensions[1] / 2],
    zoom
  );
  const br = merc.ll(
    [px[0] + dimensions[0] / 2, px[1] + dimensions[1] / 2],
    zoom
  );
  return [tl[0], br[1], br[0], tl[1]];
}

export default { viewport, bounds };
